<div class="bg-light">
  <div class="breadcrumbs-container container">
    @if (breadcrumbRoutes().length > 0) {
      <nav id="breadcrumb" aria-label="Breadcrumb">
        <ul class="breadcrumbs breadcrumbs__desktop m-0 px-0 py-2">
          @for (
            item of breadcrumbRoutes();
            track item;
            let index = $index, first = $first
          ) {
            <li class="breadcrumbs__parent-page">
              @if (!first) {
                <fa-icon class="breadcrumb__icon" icon="angle-right" />
              }
              <a
                class="breadcrumb-link"
                wlTrackLink
                [routerLink]="item.url"
                [wlAutomationId]="'breadcrumb-anchor-' + index"
                [trackLinkInfo]="{
                  rendering: { componentName: 'breadcrumb' },
                  field: item.displayName,
                  eventType: 'link-click',
                  type: 'navigation',
                }"
              >
                <span>{{ item.displayName }}</span>
              </a>
            </li>
          }

          @if (currentPage) {
            <li
              wlAutomationId="breadcrumb-current-page"
              class="breadcrumbs__current-page"
            >
              <fa-icon icon="angle-right" class="breadcrumb__icon" />
              <span class="fw-bold breadcrumbs__current-page--text">{{
                currentPage().displayName
              }}</span>
            </li>
          }
        </ul>
        <ul class="breadcrumbs breadcrumbs__mobile m-0 px-0 py-2">
          <li>
            <a
              [routerLink]="lastPage().url"
              class="breadcrumb-link"
              wlAutomationId="breadcrumb-anchor-lastPage"
              wlTrackLink
              [trackLinkInfo]="{
                rendering: { componentName: 'breadcrumb' },
                field: lastPage().displayName,
                eventType: 'link-click',
                type: 'navigation',
              }"
            >
              <fa-icon icon="angle-left" class="breadcrumb__icon" />
              <span class="fw-bold">{{ lastPage().displayName }}</span>
            </a>
          </li>
        </ul>
      </nav>
    }
  </div>
</div>
